module.exports = __webpack_public_path__ + "img/person1.c8f8ed49.png";